export default __webpack_public_path__ + "static/media/t3.71523049.png";